import { useTranslation } from "react-i18next";

import classes from "../../../../../assets/css/showCardInfo.module.css";
import icons from "../../../../../Data/icons";

const EmployeRequestsDetalis = ({ employeRequest }) => {
  const { t } = useTranslation();

  const titles = {
    id: "#",  
    name: t("Name"),
    employee:t("Employee"),    
    note: t("Note"),
    DateTo: t("DateTo"),
    DateFrom:t("Date from"),
    status: t("Status"),
  };
  const StatusIcon =icons.status
  const IdCardIcon = icons.idCard
  const AbcIcon = icons.abc
  const DateIcon = icons.date
  const UserIcon = icons.user
  const NoteIcon =icons.note
  const { id, request, employe, note, date_to,date_from , status } = employeRequest;
  return (
    <div className={classes.container}>
      <div className={classes.tableCard}>
        <div className={classes.tableCardBody}>
          <ul className={classes.ListGroup}>
            <li className={classes.listItemGroup}>
              <div className={classes.listIcon}>
                <IdCardIcon />
              </div>
              <div>
                <h5 className={classes.listTitle}>{titles.id}</h5>
                <p>{id}</p>
              </div>
            </li>
            <li className={classes.listItemGroup}>
              <div className={classes.listIcon}>
                <AbcIcon />
              </div>
              <div>
                <h5 className={classes.listTitle}>{titles.name}</h5>
                <p className={classes.listPargrah}>{request}</p>
              </div>
            </li>
            <li className={classes.listItemGroup}>
              <div className={classes.listIcon}>
                <UserIcon />
              </div>
              <div>
                <h5 className={classes.listTitle}>{titles.employee}</h5>
                <p className={classes.listPargrah}>{employe}</p>
              </div>
            </li>
            <li className={classes.listItemGroup}>
              <div className={classes.listIcon}>
              <DateIcon />
              </div>
              <div>
                <h5 className={classes.listTitle}>{titles.DateFrom}</h5>
                <p className={classes.listPargrah}>{date_from}</p>
              </div>
            </li>
            <li className={classes.listItemGroup}>
              <div className={classes.listIcon}>
                <DateIcon />
              </div>
              <div>
                <h5 className={classes.listTitle}>{titles.DateTo}</h5>
                <p className={classes.listPargrah}>{date_to}</p>
              </div>
            </li>
            <li className={classes.listItemGroup}>
              <div className={classes.listIcon}>
                <NoteIcon />
              </div>
              <div>
                <h5 className={classes.listTitle}>{titles.note}</h5>
                <p className={classes.listPargrah}>{note}</p>
              </div>
            </li>
            <li className={classes.listItemGroup}>
              <div className={classes.listIcon}>
                <StatusIcon />
              </div>
              <div>
                <h5 className={classes.listTitle}>{titles.status}</h5>
                <p className={classes.listPargrah}>{status}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default EmployeRequestsDetalis;
